import React, { useState, useEffect } from "react";
import { Select, MenuItem } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { USER_TYPE_CLIENTS, USER_TYPE_EMPLOYEES } from "src/constants/chat";
import { FlexContainer, Text } from "src/components";
import pluralize from "pluralize";
import { capitalizeString, customNames } from "src/utils/helpers";

const useStyles = makeStyles(() => ({
    outlined: {
        "&:focus": {
            outline: "none",
            background: "none"
        },
        
    }
}));

const selectStyle = {
    height: "2.5625rem",
    fontFamily: "Manrope",
    background: "var(--calendar-surface, #FFFFFF)",
    border: "1px solid var(--calendar-text, #171A22)",
    paddingLeft: "0.5rem",
    borderRadius: 7,
    "&:focus": {
        backgroundColor: "transparent"
    },
    "&:hover": {
        backgroundColor: "transparent",
    },
};

const TypeSelection = (props) => {
    const classes = useStyles();
    const { changeSelectedType, type } = props;
    const { canSeeEmployeeList, canSeeClientList } = props;
    const [selectedOption, setSelectedOption] = useState(null);
    
    useEffect(() => {
        const availableOptions = [];
        if (canSeeEmployeeList) availableOptions.push(USER_TYPE_EMPLOYEES);
        if (canSeeClientList) availableOptions.push(USER_TYPE_CLIENTS);

        // if only ONE option exists auto-select it
        if (availableOptions.length === 1) {
            handleChangeUserType(availableOptions[0]);
            return;
        }

        if (type && availableOptions.includes(type)) {
            handleChangeUserType(type);
        }

    }, [type, canSeeEmployeeList, canSeeClientList]);

    /**
    * @param {string} userListType    
    */
    const handleChangeUserType = (value) => {
        setSelectedOption(value);

        //fetch the user list via retrieveUpdatedUsersList()
        changeSelectedType(value); 
    };

    return (
        <FlexContainer>
            { props.showLabel &&
                <Text color="#4B5155" size="1rem" align="left" margin="0 0 0.8125rem 0" weight="700">
                    Select user list:
                </Text>
            }
            <Select value={selectedOption}
                variant="outlined"
                classes={{ outlined: classes.outlined }}
                onChange={e => handleChangeUserType(e.target.value)}
                style={{ 
                    ...selectStyle, 
                    width: props.width,
                    fontSize: props.fontSize || "1.125rem",
                    fontWeight: props.fontWeight || 600,
                    color: props.color || "var(--calendar-text-muted, #4B5155)",
                }}
            >
                { canSeeEmployeeList && <MenuItem value={USER_TYPE_EMPLOYEES}>{capitalizeString(pluralize(customNames.employees))}</MenuItem> }
                { canSeeClientList && <MenuItem value={USER_TYPE_CLIENTS}>{capitalizeString(pluralize(customNames.clients))}</MenuItem> }
            </Select>
        </FlexContainer>
    );
};

export default TypeSelection;
